// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"8674f80b","333":"4e688c91","520":"d45085ba"}[chunkId] + ".chunk.js";
};